import React from 'react';
import Page from "../Page";
import $ from "jquery";
import {
	Row,
	Col,
	Modal,
	Button,
   Preloader
} from "react-materialize";

import Waypoint from "react-waypoint";
import { API_REF_PULSA,API_REDEEM_PULSA,QueryParam,API_IS_REFERRAL,API_CEK_PELANGGAN,API_PULSA_DETAIL, API_BASE_URL } from "../Util";

class DetailPulsa extends Page {
   static LIMIT = 3;
   constructor(props){
      super(props);
      let params = QueryParam();

      this.state = {
         status_referral:"", 
         params: params, 
         offset: 0, 
         end: false,
         total_pulsa:"",
         total_point:"",
         total_bonus:"",
         total_code:"",
         redeem_pulsa:[],
         total_redeem:"",
         point_redeem:"",
         sudah_terkirim:"",
         belum_terkirim:"",
         belum_terkirim_redeem:"",
         sisa_point:"",
         status_redeem:"",
         sisa_redeem:"",
         message_redeem:"",
         course:[]
		};
   }

   componentDidMount(){
      Promise.all([
         this.handleTotalBonus()
      ]).then(()=>{
         this.handleIsReferral()
         this.handleRefPulsa()
         this.handleLoadData()
      })
   }

   handleIsReferral(){
		$.get(API_IS_REFERRAL).then(data => {
			this.setState({status_referral : data.status});
         if (this.state.status_referral != true){
            this.props.history.push("/")
         }
		})
	}

   handleLoadData = async (params) =>{
      let list_course = []
      if (!params) {
			params = this.state.params;
		}
		params["limit"] = DetailPulsa.LIMIT;

		params["offset"] = this.state.offset;
      console.log('offset',!params['offset']);

      this.toggleLoading(1);
     $.get(API_BASE_URL + '/course_list', params).then(result => {

         let data = result.data;
         
         for (let i = 0; i <= data.length; i++)
         {
            let list = data[i]
            list_course.push(list)

            if (!params["offset"]) {
               var list1 = list_course;
            }
            else {
               var list1 = this.state.course;
               list1.push(...list_course);
            }

            if (
               list_course.length == 0 ||
               list_course.length < DetailPulsa.LIMIT
               ) {
                  this.setState({ end: true });
                  console.log('end1', this.state.end);
               }
               
               this.setState({
                  course : list1,
                  offset: params["offset"] + DetailPulsa.LIMIT
               });
               this.toggleLoading(0);
            }
         })
   }

   _loadMoreContent = e => {   
		if (!this.state.end) {
			this.handleLoadData();
		}
	};

   toggleLoading(on) {
		if (on) {
			$(".load-more").show();
		} else {
			$(".load-more").hide();
		}
	}
   
   handleRefPulsa(){
   $.get(API_REF_PULSA).then(data =>{
         this.setState({redeem_pulsa: data.data});
      })
   }

   handlePulsaChange = e => {
      let {name, value} = e.target
      if (name == "pulsa"){
         this.setState({total_redeem: value})
      }
   }
   
   handleSubmitPulsa = async (e) => {
      e.preventDefault();
      let {total_redeem} = this.state
      $.post(API_REDEEM_PULSA, {total_redeem}).then(data =>{
         console.log('redeem pulsa', data)
         new Promise((resolve) =>{
            this.setState({
               point_redeem: data.data.total_redeem, 
               sisa_redeem: data.data.sisa, 
               status_redeem: data.status, 
               message_redeem: data.message,
               belum_terkirim_redeem: data.data.belum_dikirim
            })
         })
         console.log('redeem pulsa 1', this.state.message_redeem)
         if(data.status != false){
            $(".modal-overlay").trigger("click")
         }
      })
   }

   handleTotalBonus(){
      return $.get(API_PULSA_DETAIL).then(data => {
         console.log('cek bonus', data.data);
         this.setState({
            total_pulsa: data.data.total_pulsa,
            belum_terkirim: data.data.belum_dikirim,
            sudah_terkirim: data.data.berhasil_dikirim,
            sisa_pulsa: data.data.sisa_pulsa,
            total_code: data.data.total_code
         })
      })
   }

   render(){
      let {
         total_code,
         total_pulsa,
         total_bonus, 
         redeem_pulsa, 
         point_redeem,
         belum_terkirim,
         belum_terkirim_redeem,
         sudah_terkirim,
         status_redeem,
         message_redeem,
         sisa_redeem,
         sisa_point,
         sisa_pulsa,
         list
      } = this.state;
      
      console.log('cek title course', this.state.course);

      return (
         <div className="bg-white no-shadow container pad-m ">
            <div className="nav-wrapper">
               {/* <Row>
                  <Col className="col s12">
                     <Collapsible className="modules-collapsible">
                        <CollapsibleItem
                           header="Semua Tanggal"
                           icon="keyboard_arrow_up" 
                        >
                           <Collection>
                              <CollectionItem>
                                 
                              </CollectionItem>
                           </Collection>
                        </CollapsibleItem>
                     </Collapsible>
                  </Col>
               </Row> */}
               <Row style={{display: 'flex'}} className="mt-l">
                  <Col className="col s3">
                     <img src="img/geti-detail.png" alt="" />
                  </Col>
                  <Col className="col s9 ml-l" style={{marginLeft:"20px"}}>
                     <h4 style={{marginBottom:"0px"}}>TOTAL PULSA</h4>
                     <h2 style={{marginTop:"0px", color:"#4a65d8"}}>Rp {total_pulsa}</h2>
                  </Col>
               </Row>
               <Row style={{display:"flex", marginBottom:"15px"}}>
                  {/* <Col style={{marginLeft:"0px"}} className="col s12">
                     <p style={{marginTop:"0px"}}><b>Jumlah Kode yang Sudah digunakan : <h5 style={{ display:"inline",color:"#4a65d8"}}>{total_code} </h5></b></p>
                  </Col> */}
                  <Col style={{marginLeft:"0px", borderRight:"2px solid #0559f3"}} className="col s4">
                     <p style={{marginTop:"0px"}}>Kode Sudah digunakan</p>
                     <h5 style={{ color:"#4a65d8"}}>{total_code}</h5>
                  </Col>
                  {/* <Col style={{marginLeft:"20px",width:"20%", borderRight:"2px solid #0559f3"}} className="col s2">
                     <p style={{marginTop:"0px"}}>Jumlah pulsa</p>
                     <h5 style={{color:"#4a65d8"}}>Rp {total_pulsa}</h5>
                  </Col>
                  {
                     sisa_point != 0 ?
                        <Col style={{marginLeft:"20px",width:"20%", borderRight:"2px solid #45f79e"}} className="col s2">
                           <p style={{marginTop:"0px"}}>Jumlah Bonus</p>
                           <h5 style={{ color:"#4a65d8"}}>Rp {total_bonus}</h5>
                        </Col>
                        :
                        <Col style={{marginLeft:"20px",width:"20%", borderRight:"2px solid red"}} className="col s2">
                           <p style={{marginTop:"0px"}}>Jumlah Bonus</p>
                           <h5 style={{ color:"#4a65d8"}}>Rp {total_bonus}</h5>
                        </Col>

                  } */}
                  {
                     status_redeem == true ? 
                        sisa_point != 0 ? 
                           <Col style={{marginLeft:"20px"}} className="col s8">
                              <p style={{marginTop:"0px", color:"#45f79e"}}>Pulsa Belum di Redeem</p>
                              <h5 style={{ color:"#45f79e"}}>Rp {sisa_redeem}</h5>
                           </Col>
                           :
                           <Col style={{marginLeft:"20px"}} className="col s8">
                              <p style={{marginTop:"0px", color:"red"}}>Pulsa Belum di Redeem</p>
                              <h5 style={{ color:"red"}}>Rp {sisa_redeem}</h5>
                           </Col>
                        :
                        sisa_point != 0 ? 
                           <Col style={{marginLeft:"20px"}} className="col s8">
                              <p style={{marginTop:"0px", color:"#45f79e"}}>Pulsa Belum di Redeem</p>
                              <h5 style={{ color:"#45f79e"}}>Rp {sisa_pulsa}</h5>
                           </Col>
                           :
                           <Col style={{marginLeft:"20px"}} className="col s8">
                              <p style={{marginTop:"0px", color:"red"}}>Pulsa Belum di Redeem</p>
                              <h5 style={{ color:"red"}}>Rp {sisa_pulsa}</h5>
                           </Col>
                  }
               </Row>
               <Row style={{display: "flex"}}>
                  <Col s={6} m={6} l={6} className="fadeIn" >
                     <Row style={{
                              display: "block",
                              minHeight:"80px", 
                              backgroundColor:"#c5ffdc", 
                              border: "1px solid", 
                              borderColor:"#c5ffdc",
                              borderRadius:"5px"
                           }}
                           className="align-items-top mb-m">
                              <p className="ml-s">
                                 <b>
                                    Berhasil
                                 </b>
                                    &nbsp; dikirimkan
                              </p>
                                 <h5 style={{ color:"#4a65d8"}} className="ml-s">Rp {sudah_terkirim}</h5>
                     </Row>
                  </Col>
                  <Col s={6} m={6} l={6} className="fadeIn" style={{ marginLeft:"20px"}}>
                     <Row style={{
                              minHeight:"80px", 
                              backgroundColor:"#ffb6c1", 
                              border: "1px solid", 
                              borderColor:"#ffb6c1",
                              borderRadius:"5px"
                           }} className="mb-m">
                              <p className="ml-s">
                                 <b>
                                    Belum
                                 </b>
                                    &nbsp; dikirimkan
                              </p>
                              {
                                 status_redeem == true ?
                                    <h5 style={{ color:"#4a65d8"}} className="ml-s">Rp {belum_terkirim_redeem}</h5>
                                    :
                                    <h5 style={{ color:"#4a65d8"}} className="ml-s">Rp {belum_terkirim}</h5>

                              }
                     </Row>
                  </Col>
               </Row>
               <Row>
                  {/* <Button style={{ width:"100%", marginBottom:"20px"}}className="btn btn-block">REDEEM</Button> */}
                  <Modal
                      id="modal-box"
                      trigger={
                        <Button style={{ width:"100%", marginBottom:"20px"}}className="btn btn-block ">REDEEM</Button>
                      }
                    >
                      <div className="mt-l">
                      <h4 >Nominal Voucher</h4>
                      <div className="row">
                        <form onSubmit={async (e) => await this.handleSubmitPulsa(e)}>
                          <div className="col s12">
                           <div className="input-field">
                              <select
                                 name="pulsa"
                                 className="drop-down"
                                 value={this.state.total_redeem}
                                 onChange={this.handlePulsaChange}
                              >
                                 <option value="" disabled >Pilih nominal voucher</option>
                                 {
                                    redeem_pulsa.map((item) => (

                                       <option value={item.price}>Rp {item.rupiah}</option>
                                    ))
                                 }
                              </select>
                           </div>
                           {
                              status_redeem == false ?
                                 <p style={{ color:"red" }}>{message_redeem}</p> : ""
                           }
                           <div style={{ display:"flex", justifyContent: "center" }}>
                              <button className="btn btn-sm">REDEEM</button>
                           </div>
                          </div>
                        </form>
                      </div>
                      </div>
                    </Modal>
               </Row>
               <Row>
                  <Button 
                     onClick={()=>{
                        this.props.history.push('/referral#tab_1', {skema : 1})
                     }} 
                     style={{ width: "100%"}}
                     className="btn btn-block">
                        LIHAT SKEMA PULSA</Button>
               </Row>
               {/* <Row className="mt-xl">
                  <Col l={5} m={5} s={12} style={{ marginRight:"90px" }}>
                     <p><b>Status</b></p>
                     <div className="input-field">
								<select
									name="study"
									className="drop-down "
								>
									<option value="" disabled>Pilih Status</option>
								</select>
							</div>
                  </Col>
                  <Col l={5} m={5} s={12}>
                  <p><b>Menampilkan</b></p>
                     <div className="input-field">
								<select
									name="study"
									className="drop-down "
								>
									<option value="" disabled>Hasil</option>
								</select>
							</div>
                  </Col>
               </Row> */}
               {
                  this.state.course.length != 0 ? 
                     <Row style={{ marginTop:"50px"}}>
                        <div style={{ display:"flex", justifyContent: "center" }}>
                           <h5>Daftar Kelas dengan Kode Referral</h5>
                        </div>
                        <div style={{ display:"flex", justifyContent: "center" }}>
                                 <ol>
                                    {
                                       this.state.course.map(item => (
                                          item != undefined ? 
                                             <li style={{ fontSize:"14px", lineHeight:"28px" }}>{item.title}, Kode : <b>{item.referral_code}</b></li>
                                          :
                                             ""
                                       ))
                                    }
                                    <Waypoint onEnter={this._loadMoreContent} />
                                    {!this.state.end && (
                                       <div className="center load-more mt-m">
                                          <Preloader size="medium" />
                                       </div>
                                    )}
                                 </ol>
                        </div>
                     </Row >
                  :
                  <Row style={{ marginTop:"50px"}}>
                     <div style={{ display:"flex", justifyContent: "center" }}>
                        <h5>Anda Belum Menggunakan Kode Referral</h5>
                     </div>
                  </Row>
               }
            </div>
         </div>
      )
   }
}

export default DetailPulsa


// WEBPACK FOOTER //
// ./src/components/Referral/DetailPulsa.js